/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Accordion_PublisherInputs */

const id_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penerbit`)
};

const ms_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penerbit`)
};

const da_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forlægger`)
};

const de_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herausgeber`)
};

const en_us2_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publisher`)
};

const es_es2_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const es_mx2_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicador`)
};

const fil_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publisher`)
};

const fr_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éditeur`)
};

const it_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editore`)
};

const hu_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiadó`)
};

const nl_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgever`)
};

const no_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgiver`)
};

const pl_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydawca`)
};

const pt_br2_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const pt_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editora`)
};

const ro_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const fi_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaisija`)
};

const sv_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgivare`)
};

const vi_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà xuất bản`)
};

const tr_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayıncı`)
};

const cs_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vydavatel`)
};

const bg_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Издател`)
};

const ru_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Издатель`)
};

const uk_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видавець`)
};

const ar_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الناشر`)
};

const hi_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशक`)
};

const th_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้จัดจำหน่าย`)
};

const ja_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パブリッシャー`)
};

const zh_cn2_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发行商`)
};

const zh_hant1_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發行商`)
};

const ko_search_accordion_publisher = /** @type {(inputs: Search_Accordion_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배급사`)
};

/**
* | output |
* | --- |
* | "Publisher" |
*
* @param {Search_Accordion_PublisherInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_accordion_publisher = /** @type {((inputs?: Search_Accordion_PublisherInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Accordion_PublisherInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_accordion_publisher(inputs)
	if (locale === "ms") return ms_search_accordion_publisher(inputs)
	if (locale === "da") return da_search_accordion_publisher(inputs)
	if (locale === "de") return de_search_accordion_publisher(inputs)
	if (locale === "en-US") return en_us2_search_accordion_publisher(inputs)
	if (locale === "es-ES") return es_es2_search_accordion_publisher(inputs)
	if (locale === "es-MX") return es_mx2_search_accordion_publisher(inputs)
	if (locale === "fil") return fil_search_accordion_publisher(inputs)
	if (locale === "fr") return fr_search_accordion_publisher(inputs)
	if (locale === "it") return it_search_accordion_publisher(inputs)
	if (locale === "hu") return hu_search_accordion_publisher(inputs)
	if (locale === "nl") return nl_search_accordion_publisher(inputs)
	if (locale === "no") return no_search_accordion_publisher(inputs)
	if (locale === "pl") return pl_search_accordion_publisher(inputs)
	if (locale === "pt-BR") return pt_br2_search_accordion_publisher(inputs)
	if (locale === "pt") return pt_search_accordion_publisher(inputs)
	if (locale === "ro") return ro_search_accordion_publisher(inputs)
	if (locale === "fi") return fi_search_accordion_publisher(inputs)
	if (locale === "sv") return sv_search_accordion_publisher(inputs)
	if (locale === "vi") return vi_search_accordion_publisher(inputs)
	if (locale === "tr") return tr_search_accordion_publisher(inputs)
	if (locale === "cs") return cs_search_accordion_publisher(inputs)
	if (locale === "bg") return bg_search_accordion_publisher(inputs)
	if (locale === "ru") return ru_search_accordion_publisher(inputs)
	if (locale === "uk") return uk_search_accordion_publisher(inputs)
	if (locale === "ar") return ar_search_accordion_publisher(inputs)
	if (locale === "hi") return hi_search_accordion_publisher(inputs)
	if (locale === "th") return th_search_accordion_publisher(inputs)
	if (locale === "ja") return ja_search_accordion_publisher(inputs)
	if (locale === "zh-CN") return zh_cn2_search_accordion_publisher(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_accordion_publisher(inputs)
	return ko_search_accordion_publisher(inputs)
});
export { search_accordion_publisher as "search.accordion.publisher" }